export default __webpack_public_path__ + "images/932fdcf7b7f47ff164ab48030ad1729f.png";